// ════════════════════════════════════════════════════════════
//  hudView.js — what is ON SCREEN during a fight (caP'n, 2026-10-17)
// ════════════════════════════════════════════════════════════
//  "every single piece should have a hide button so you can clear the screen of all
//  words and just watch the match in all its glory."
//  One tiny store, so the HUD, the Front Row bar, the chat and App's status line all
//  agree. Hiding is CSS only (the .hud gets a `hide-<piece>` class) — nothing unmounts,
//  so the banner/log event cursors never replay old events when a piece comes back.
//   • hidden pieces are remembered in this browser (localStorage) — they stay hidden
//     in the next fight until you show them again.
//   • CLEAR (key H, or the eye menu) hides everything at once; it is NOT remembered —
//     the next fight starts with the pieces you left showing.
// ════════════════════════════════════════════════════════════
import { useSyncExternalStore } from "react";

// every piece you can hide, in the order the menu lists them
export const PIECES = ["vs", "calls", "left", "right", "clock", "actions", "log", "banners", "hints", "front", "chat", "status", "buttons"];   // "calls": a partner's callouts (LYRAEI PLAYS)
const KEY = "shatterproof.hudview.v1";

function load() {
  try {
    const j = JSON.parse(localStorage.getItem(KEY) || "{}");
    return Array.isArray(j.hidden) ? j.hidden.filter((x) => PIECES.includes(x)) : [];
  } catch { return []; }
}
function save(hidden) { try { localStorage.setItem(KEY, JSON.stringify({ hidden })); } catch { /* private window: it just won't be remembered */ } }

let state = { hidden: load(), clear: false };
const subs = new Set();
const set = (next) => { state = next; subs.forEach((f) => f()); };

export const toggle = (id) => {
  if (!PIECES.includes(id)) return;
  const hidden = state.hidden.includes(id) ? state.hidden.filter((x) => x !== id) : [...state.hidden, id];
  save(hidden); set({ ...state, hidden });
};
export const toggleClear = () => set({ ...state, clear: !state.clear });
export const showAll = () => { save([]); set({ hidden: [], clear: false }); };

export function useHudView() {
  return useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => state);
}
// the class list for the .hud root
export const hudClass = (v) => ["hud", v.clear ? "clear" : "", ...v.hidden.map((h) => "hide-" + h)].filter(Boolean).join(" ");
// is this piece showing right now?
export const isShown = (v, id) => !v.clear && !v.hidden.includes(id);
